@use "../../sass/global/global" as *;

:host {
    display: block;
    box-sizing: border-box;
    background:
        linear-gradient(291deg, rgba(0, 80, 116, 0) -41.04%, #005074 99.07%),
        var(--ux-iws-field-service-search-background-image) lightgray 50% /
            cover no-repeat;
    padding: 30px;
}

:host * {
    box-sizing: inherit;
}

.initial-container {
    display: flex;
    align-items: flex-start;

    @media (max-width: 400px) {
        flex-direction: column;
        align-items: center;
    }
}

.intro-text {
    flex-grow: 1;
    padding-right: 20px;
}

form {
    width: 50%;
    max-width: 360px;
    background-color: #fff;
    padding: 30px;
    display: flex;
    align-items: flex-end;

    @media (max-width: 600px) {
        width: 100%;
    }
}

ux-input-field {
    flex-grow: 1;
}

ux-button {
    --ux-button-primary-bg-color: #000;
    margin-left: -2px;
}

.results {
    margin-top: 30px;
    border-top: solid 1px rgba(255, 255, 255, 0.5);
    padding: 10px 0;
}

.results-title {
    @include nb-heading(6, true);
    color: #fff;
}

.no-results {
    margin-top: 30px;
    border-top: solid 1px rgba(255, 255, 255, 0.5);
    padding: 10px 0;
}

.no-results.hidden,
.results.hidden {
    display: none;
}
